import React from 'react';
import { PropTypes } from 'prop-types';
import { Grid } from '@mui/material';
import { AboutCard, CreditCard, PeopleCard } from '../../index';

export const CustomerOverview = ({ customer }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={2} />
      <Grid item xs={4}>
        <AboutCard customer={customer} />
      </Grid>
      <Grid container item xs={4} spacing={2}>
        <Grid item xs={12}>
          <PeopleCard customer={customer} />
        </Grid>
        <Grid item xs={12}>
          <CreditCard credit={customer?.credit} />
        </Grid>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={2} />
    </Grid>
  );
};

CustomerOverview.propTypes = {
  customer: PropTypes.shape({
    credit: PropTypes.object,
  }),
};

export default CustomerOverview;
